import { Lock } from 'iconsax-react'
import React from 'react'

import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { SocialMirrorPalette } from '@/utils/palette/SocialMirrorPalette'

const PLACEHOLDER_ROWS = ['?', '?', '?', '?', '?']

/**
 * Blurred, non-interactive placeholder list shown after the free screening.
 * The count is real but the rows are fake — actual profiles unlock after payment.
 */
export const MockImpersonatorList = ({ count }: { count: number }) => {
  const rows = PLACEHOLDER_ROWS.slice(0, Math.max(Math.min(count, 5), 1))

  return (
    <div className="relative w-full">
      <div
        className="flex flex-col gap-3 w-full blur-[5px] select-none pointer-events-none"
        aria-hidden="true"
      >
        {rows.map((placeholder, index) => (
          <div
            key={index}
            className="bg-baseColor rounded-2xl flex flex-row items-center gap-3 p-3 h-[65px] w-full"
          >
            <Avatar>
              <AvatarFallback className="bg-baseColorHighlight text-neutralColor">
                {placeholder}
              </AvatarFallback>
            </Avatar>
            <div className="flex flex-col gap-2 flex-1">
              <div className="h-3 w-1/3 rounded-full bg-neutralColor30" />
              <div className="h-2 w-1/4 rounded-full bg-neutralColor30" />
            </div>
            <div className="h-6 w-20 rounded-full bg-neutralColor30" />
          </div>
        ))}
      </div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="flex items-center justify-center w-14 h-14 rounded-full bg-baseColorHighlight shadow-lg">
          <Lock size={26} color={SocialMirrorPalette.primary} variant="Bold" />
        </div>
      </div>
    </div>
  )
}
